import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CreateColumnRequest, DeleteColumnRequest, KCC_App_SharepointSiteLinks, SharePointRedirectMicrosoftRequest, UpdateColumnRequest } from 'src/app/Models/azure';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class azureService {
    private headers: HttpHeaders;
    private urlHeaders: HttpHeaders;

    constructor(private http: HttpClient, private router: Router, private toaster: ToastrService) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
        this.urlHeaders = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    }

    handleTokenExchangeSuccess(token: any, State: any, urlRedirect: string = ''): void {
        this.SPBrowserStorage(token.access_token, token.refresh_token, token.tokenExpiresAtUtc, State);
        if (urlRedirect == '') {
            this.toaster.error(`Redirect URL is not Configured`, 'Sharepoint Connection');
        }
        this.router.navigate([urlRedirect])
            .then(() => {
                this.toaster.success(`The connection with Microsoft-SharePoint has been connected.`, 'Sharepoint Connection');
            })
            .catch((error) => {
                this.toaster.error(error, 'Sharepoint Connection');
            });
    }

    handleTokenExchangeError(error: any): void {
        sessionStorage.removeItem('codeVerifier');
        this.toaster.error('Token exchange error: ' + error.error, 'Sharepoint Connection');
    }

    SPBrowserStorage(access_token: any, refresh_token: any, expires_in: any, State: any) {
        sessionStorage.setItem('SPDMSState', State);
    }

    GetSPSettings() {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
        let apiUrl = 'api/Azure/GetSPSettings';
        return this.http.get<any>(apiUrl, { headers: this.headers });
    }

    exchangeCodeForToken(code: string, scopes: string[], state: any, urlRedirect: string = null, UserType: string = 'Authoriser') {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
        let apiUrl = 'api/Azure/ExchangeCodeForToken';
        return this.http.post<any>(apiUrl, { code, scopes, state, urlRedirect, UserType }, { headers: this.headers });
    }

    redirectToMicrosoft(stateId: any, spConnectionType: any, callbackURL: string = null,UserType: string = 'Authoriser') {
        const apiUrl = `api/Azure/RedirectToMicrosoft`;
        try {
            let request: SharePointRedirectMicrosoftRequest = {
                CallbackURL: callbackURL,
                SpConnectionType: spConnectionType,
                StateId: stateId.toString(),
                UserType:UserType
            }
            this.http.post<any>(apiUrl, request, { headers: this.headers }).subscribe((result: any) => {
                if (result) {
                    window.open(result, '_self');
                }
            });
        } catch (error) {
            this.toaster.error('Error during API call:', 'Sharepoint Connection');
        }
    }

    logout(sharepointPracticeId: any, AzureSPSettings: any, userType: any) {
        const url = `api/Azure/SharepointLogout/${sharepointPracticeId}/${userType}`;
        this.http.get<any>(url).subscribe((result: any) => {
            if (result) {
                this.toaster.success('Disconnected.', 'Sharepoint Connection');
                this.clearSPBrowserStorage();
                const logoutUrl = AzureSPSettings.instance + AzureSPSettings.tenantId + AzureSPSettings.azureAuthLogout;
                const redirectUri = environment.apiClientPath + AzureSPSettings.reloadUri;
                window.location.href = `${logoutUrl}post_logout_redirect_uri=${encodeURIComponent(redirectUri)}`;
            }
            else {
                this.toaster.error('Please try to disconnect.', 'Sharepoint Connection');
            }
        }, (error: any) => this.toaster.error('Please try to disconnect.', 'Sharepoint Connection'));
    }

    SoftDeleteSharePointById(sharepointPracticeId: any) {
        const url = `api/Azure/DeleteSharepointPracticeDetailById/${sharepointPracticeId}`;
        this.http.get<any>(url).subscribe((result: any) => {
            if (result) {
                this.toaster.success('Sharepoint connection deleted.', 'Sharepoint Connection');
                this.clearSPBrowserStorage();
            }
            else {
                this.toaster.error('Please try to delete again.', 'Sharepoint Connection');
            }
        }, (error: any) => this.toaster.error('Something went wrong', 'Sharepoint Connection'));
    }

    clearSPBrowserStorage() {
        sessionStorage.removeItem('SPDMSCode');
        sessionStorage.removeItem('codeVerifier');
        sessionStorage.removeItem('SPDMSAccessToken');
        sessionStorage.removeItem('SPDMSRefreshToken');
        sessionStorage.removeItem('SPDMSExpiresIn');
        localStorage.removeItem('SPDMSAccessToken');
        sessionStorage.removeItem('SPDMSState');
    }

    GetAllSharepointPracticeList(UserType: string = 'Authoriser') {
        return this.http.get<any>('api/Azure/GetAllSharepointList/' + UserType);
    }
    GetSharepointPracticeById(sharepointPracticeId) {
        return this.http.get<any>('api/Azure/GetSharepointPracticeById?sharepointPracticeId=' + sharepointPracticeId);
    }

    GetSharepointSiteLinks() {
        return this.http.get<any>('api/Azure/sharepoint/configuration/GetSharepointSiteLinks')
    }

    GetSiteMetadatas() {
        return this.http.get<any>('api/Azure/sharepoint/configuration/GetSiteMetadatas')
    }
    GetSiteMetadataById(metadataId: any) {
        return this.http.get<any>('api/Azure/sharepoint/configuration/GetSiteMetadataById/' + metadataId)
    }

    UpdateColumn(columnObj: UpdateColumnRequest) {
        return this.http.post<any>('api/Azure/sharepoint/configuration/UpdateColumn', columnObj, { headers: this.headers });
    }

    CreateColumn(columnObj: CreateColumnRequest) {
        return this.http.post<any>('api/Azure/sharepoint/configuration/CreateColumn', columnObj, { headers: this.headers });
    }

    DeleteColumn(columnObj: DeleteColumnRequest) {
        return this.http.post<any>('api/Azure/sharepoint/configuration/DeleteColumn', columnObj, { headers: this.headers });
    }

    LinkSite(siteObject: KCC_App_SharepointSiteLinks) {
        return this.http.post<any>('api/Azure/sharepoint/configuration/AddUpdateSharepointSiteLink', siteObject, { headers: this.headers });
    }

    UpdateSiteStatus(siteId: any, status: any) {
        return this.http.get<any>('api/Azure/sharepoint/configuration/SetSiteStatus/' + siteId + '/' + status);
    }
    UpdateSiteMetadataStatus(siteId: any, status: any) {
        return this.http.get<any>('api/Azure/sharepoint/configuration/SetSiteMetadataStatus/' + siteId + '/' + status);
    }
    RemoveSharepointSiteLink(sharepointSiteLinkId: any) {
        return this.http.get<any>('api/Azure/sharepoint/configuration/RemoveSharepointSiteLink/' + sharepointSiteLinkId);
    }
    RemoveSiteMetadata(sitemetadataId: any) {
        return this.http.get<any>('api/Azure/sharepoint/configuration/RemoveSiteMetadata/' + sitemetadataId);
    }
    getSiteDataById(siteId: any) {
        return this.http.get<any>('api/Azure/sharepoint/configuration/GetSharepointSiteLink/' + siteId);
    }
    AddEditSharepointPractice(sharepointPractice) {
        return this.http.post<any>('api/Azure/AddEditSharepointPractice', sharepointPractice);
    }
    createClientFolder(createClientModel) {
        return this.http.post<any>('api/Azure/CreateClientFolder', createClientModel);
    }

    GetSiteUrl(siteName: any,) {
        const url = `api/Azure/sharepoint/search/${siteName}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    CreateClientFolderStructure(ceateClientFolderStructureModel) {
        return this.http.post<any>('api/Azure/CreateClientFolderStructure', ceateClientFolderStructureModel);
    }

    GetSPMigrationSiteLinks() {
        return this.http.get<any>('api/spsync_migration/GetSPMigrationSiteLinks')
    }

    CreateSiteJobToSyncMigrate(siteId: any, spJobId: any) {        
        return this.http.get('api/MultiAFJob/start/' + siteId + '/' + spJobId, { responseType: 'text' });
    }
    CancelSiteJobToSyncMigrate(siteId: any, spJobId: any) {        
        return this.http.get('api/MultiAFJob/stop/' + siteId + '/' + spJobId, { responseType: 'text' });
    }

    UpdateSiteMetadataIsDefaultRootFolder(siteId: any, isDefaultRootFolder: any) {
        return this.http.get<any>('api/Azure/sharepoint/configuration/UpdateSiteMetadataIsDefaultRootFolder/' + siteId + '/' + isDefaultRootFolder);
    }

    UpdateClientFolder(clientCategory) {
        return this.http.post<any>('api/Azure/UpdateClientFolder', clientCategory, { headers: this.headers });
    }
}
